import { useDispatch, useSelector } from "react-redux";
import {
  setOffSeasonEvent,
  setVideoList,
} from "../../../Redux/Actions/PastSeasonActions";
import PastSeasonColumnContainer from "./PastSeasonColumnContainer";

const OffSeasonEventList = ({
  active,
  setActive,
  setActivePractice,
  setSelectedVideos,
}) => {
  const dispatch = useDispatch();
  const selectedEvent = useSelector(
    (state) => state.selectedSeasonData.selectedEventData
  );

  const handleEventClick = (el) => {
    if (active?.eventName === el.eventName) {
      setActive(null);
      setOffSeasonEvent(dispatch, null);
    } else {
      setOffSeasonEvent(dispatch, el);
      setActive(el);
    }
    setVideoList(dispatch, null);
    setActivePractice(null);
    setSelectedVideos([]);
  };
  return (
    <>
      {typeof selectedEvent === "object" &&
      Object.keys(selectedEvent).length &&
      selectedEvent[0]?.eventName ? (
        <PastSeasonColumnContainer
          heading={"Off Season Event's"}
          data={selectedEvent}
          handleClick={handleEventClick}
          active={active}
          fieldToShow={"eventName"}
          isObject={true}
        />
      ) : null}
    </>
  );
};

export default OffSeasonEventList;
